import React from 'react'
import { Link } from "gatsby"

const HoverSection = ({
  header,
  text,
  link,
  linkText,
  isActive,
  modifier,
  onMouseEnter,
  image
}) => {
  return (
    <section
      className={`banner-full__section banner-full__section--${modifier} ${isActive ? 'banner-full__section--active' : ''}`}
      onMouseEnter={onMouseEnter}
    >
      <div className="banner-full__content-wrapper">
        <h2>{header}</h2>
        <div className="banner-full__content">
          <p>{text}</p>
          <Link to={link} className="button">
            {linkText}
          </Link>
        </div>
      </div>
      <div
        className={`banner-full__background ${!isActive ? 'banner-full__background--hidden' : ''}`}
      >
        <img src={image} alt='' loading='lazy' />
      </div>
    </section>
  )
}

export default HoverSection
